import React, {useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {useParams} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import * as actions from '../_redux/userDetailsActions';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';

const PopupDeleteFile = ({
                           fileName,
                           fileMongoID
                         }) => {
  const dispatch = useDispatch();
  const user = useSelector(
    (state) => state.userDetails.user,
    shallowEqual
  );
  const intl = useIntl();
  const prefix = 'userDetails-files-modal-delete';
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const userMongoID = useParams().userId;

  const deleteFile = () => {
    const {email} = user;
    dispatch(actions.deleteFile({userMongoID, fileName, fileMongoID, email}))
      .then(() => {
        dispatch(actions.fetchUser({userId: userMongoID}));
      })
      .catch((error) => {
        console.error(`Error: + ${error}`);
      })
  };

  return (
    <>
      <Button
        variant="outline-primary"
        className="d-flex align-items-center justify-content-between m-0 custom-button-primary"
        onClick={handleShowModal}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Deleted-file.svg')}
          alt="delete-file"
        />
      </Button>
      <Modal show={show} onHide={handleCloseModal}>
        <div className={'p-6'}>
          <Modal.Title className={'text-primary text-center mb-4'}>
            <div>{intl.formatMessage({id: `${prefix}-text`, defaultMessage: 'Delete file'})}</div>
            <div>{fileName}</div>
          </Modal.Title>
          <div className={'d-flex justify-content-center'}>
            <Button size="sm" className={'w-100px'} variant="secondary" onClick={handleCloseModal}>
              {intl.formatMessage({id: `${prefix}-cancel`, defaultMessage: 'Cancel'})}
            </Button>
            <Button size="sm" className={'w-100px ml-8'} variant="primary" onClick={deleteFile}>
              {intl.formatMessage({id: `${prefix}-ok`, defaultMessage: 'OK'})}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PopupDeleteFile;
